import { Card, Divider } from 'antd';
import Title from 'antd/lib/typography/Title';
import { NextPage } from 'next';
import { useIntl } from 'react-intl';
import { HeaderProps, PageWrapper } from '../../components/page-wrapper';
import { TENANT_NAME } from '../../tenant/tenant-names';
import styles from './credits.module.scss';

const Credits: NextPage = () => {
  const { formatMessage } = useIntl();

  const links: string[] = [
    // accept.jpg
    'https://www.freepik.com/free-vector/yes-no-concept-illustration_19948566.htm#query=accept&position=3&from_view=search&track=sph',
    // account-verification.jpg
    // email-confirmation.jpg
    'https://www.freepik.com/free-vector/email-marketing-internet-chatting-24-hours-support_12084798.htm#query=email&position=0&from_view=search&track=sph',
    // app.jpg
    'https://www.freepik.com/free-vector/appointment-booking-design_8431429.htm#query=app&position=46&from_view=search&track=sph',
    // appointment.jpeg
    'https://www.freepik.com/free-vector/call-doctor-concept-doctors-answer-patient-questions-phone_18707003.htm#query=appointment%20hospital&position=19&from_view=search&track=sph',
    // appointment-request.jpg
    'https://www.freepik.com/free-vector/employee-marking-deadline-day-man-with-pencil-appointing-date-event-making-note-calendar-vector-illustration-schedule-agenda-time-management_10172651.htm#query=appointment&from_query=appointment%20request&position=11&from_view=search&track=sph',
    // appointments.jpg
    'https://www.freepik.com/free-vector/people-using-online-appointment-booking-app_8271067.htm#query=appointment%20booking&position=0&from_view=search&track=sph',
    // background.jpg

    // data-collection.jpg
    'https://www.freepik.com/free-vector/documents-concept-illustration_4957415.htm#query=documents&position=5&from_view=search&track=sph',

    // data-processing.jpg
    'https://www.freepik.com/free-vector/data-report-illustration-concept_6195527.htm#query=data&position=1&from_view=search&track=sph',
    // data-security.jpg
    'https://www.freepik.com/free-vector/global-data-security-personal-data-security-cyber-data-security-online-concept-illustration-internet-security-information-privacy-protection_12953631.htm#query=data%20protection&position=4&from_view=search&track=sph',
    // documents.jpg
    'https://www.freepik.com/free-vector/online-document-concept-illustration_13338131.htm#query=documents&from_query=personal%20documents&position=26&from_view=search&track=sph',
    // encryption.jpg
    'https://www.freepik.com/free-vector/online-document-concept-illustration_13338131.htm#query=documents&from_query=personal%20documents&position=26&from_view=search&track=sph',

    // gdpr.jpg
    'https://www.freepik.com/free-vector/tiny-people-protecting-business-data-legal-information-isolated-flat-illustration_11235938.htm#query=gdpr&position=4&from_view=search&track=sph',

    // hosting.jpg
    'https://www.freepik.com/free-vector/computer-technology-isometric-icon-server-room-digital-device-set-element-design-pc-laptop_4103157.htm#query=server&position=0&from_view=search&track=sph',
    // info.jpg
    'https://www.freepik.com/free-vector/hospital-service-concept-flat-illustration_18706987.htm#query=doctor%20patient%20appointment&position=2&from_view=search&track=sph',
    // legal-guardian.jpg
    'https://www.freepik.com/free-vector/guardianship-abstract-concept-vector-illustration-child-custody-legal-guardian-authority-stepfather-stepmother-foster-care-parent-family-lawyer-happy-parenting-adoption-abstract-metaphor_11668229.htm#query=guardianship&position=9&from_view=search&track=sph',
    // link-account.jpg
    'https://www.freepik.com/free-vector/cloud-computing-concept_3584916.htm#query=link&position=1&from_view=search&track=sph',

    // medical-data.png
    'https://www.freepik.com/free-vector/big-data-healthcare-abstract-concept-illustration_12291152.htm#query=hospital%20data&position=32&from_view=search&track=sph',

    // two-factor-auth.jpg
    'https://www.freepik.com/free-vector/two-factor-authentication-concept-illustration_13246824.htm#query=two%20factor%20authentication&from_query=two%20factor&position=0&from_view=search&track=sph',

    // user.jpg
    'https://www.freepik.com/free-vector/character-illustration-people-holding-user-account-icons_3226077.htm#query=user&position=12&from_view=search&track=sph',

    // ward.jpg
    'https://www.freepik.com/free-vector/different-generation-set_6974878.htm#query=elderly&position=0&from_view=search&track=sph',
  ];

  return (
    <PageWrapper headerProps={headerProps}>
      <Card>
        <Title>{formatMessage({ id: 'credits.title' })}</Title>
        <div className={styles.text}>
          <p>{formatMessage({ id: 'credits.text' }, { tenant: TENANT_NAME })}</p>
          <Divider />

          <ul>
            {links.map((link) => {
              return (
                <li key={link} className={styles.link}>
                  <a href={link} target={'_blank'} rel={'noreferrer'}>
                    {link}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </Card>
    </PageWrapper>
  );
};

const headerProps: HeaderProps = {
  title: 'Credits',
};

export default Credits;
